// extracted by mini-css-extract-plugin
export var orderDetails = "_rd-2";
export var orderImage = "_rd-1";
export var orderMeta = "_rd-3";
export var orderSummary = "_rd-0";
export var rightArrow = "_rd-4";